import { render, staticRenderFns } from "./rolesConfig.vue?vue&type=template&id=86884ee6&scoped=true"
import script from "./rolesConfig.vue?vue&type=script&lang=js"
export * from "./rolesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86884ee6",
  null
  
)

export default component.exports